import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
// Generated by Copilot — Migrated from Userfront to Clerk
import useAuthHeaders from '../hooks/useAuthHeaders';

const API_URL = process.env.REACT_APP_API_URL;

const FeatureRoute = ({ feature, children }) => {
  const [status, setStatus] = useState('loading');
  const { getToken } = useAuthHeaders();

  useEffect(() => {
    const checkFeature = async () => {
      try {
        const token = await getToken();
        const response = await fetch(`${API_URL}/Users/features`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (response.ok) {
          const data = await response.json();
          const allowed = (data.features || []).includes(feature);
          setStatus(allowed ? 'allowed' : 'denied');
        } else {
          setStatus('denied');
        }
      } catch {
        setStatus('denied');
      }
    };
    checkFeature();
  }, [feature, getToken]);

  if (status === 'loading') return null;
  if (status === 'denied') return <Navigate to="/" replace />;
  return children;
};

export default FeatureRoute;
